<template lang="pug">
a.notification(
  :href="link"
  :class="notificationClass"
  target="_blank"
)
  .notification__inner
    .notification__header
      .notification__header-left
        img.notification__avatar(
          :src="userAvatar"
        )
      .notification__header-right
        .notification__user-name {{userName}}
        .notification__date {{notificationDate}}
    .notification__content(
      v-html="notificationContent"
    )
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'Notification',

    props: {
      link: {
        type: String as PropType<string>,
        required: true,
      },
      userName: {
        type: String as PropType<string>,
        required: true,
      },
      userAvatar: {
        type: String as PropType<string>,
        required: true,
      },
      notificationDate: {
        type: String as PropType<string>,
        required: true,
      },
      notificationContent: {
        type: String as PropType<string>,
        required: true,
      },
      isRead: {
        type: Boolean as PropType<boolean>,
        required: true,
      },
    },

    computed: {
      notificationClass() {
        return {
          'notification--is-read': this.isRead,
        };
      },
    },
  });
</script>

<style scoped lang="scss">
  .notification {
    $notification: &;

    display: block;
    text-decoration: none;
    color: inherit;
    position: relative;
    overflow: hidden;
    background-color: #f3f5fc;

    &:first-of-type {
      #{$notification} {
        &__inner {
          &:before {
            display: none;
          }
        }
      }
    }

    @include hover {
      background-color: #e1eafd;
    }

    &--is-read {
      background-color: white;

      & + & {
        #{$notification} {
          &__inner {
            &:before {
              content: '';
              position: absolute;
              display: block;
              left: 0;
              right: 0;
              top: 0;
              border-bottom: 1px solid #e7e7e7;
            }
          }
        }
      }
    }

    &__inner {
      position: relative;
      margin: 0 16px 16px 16px;
      padding-top: 16px;

      @include tablet {
        margin: 0 24px 24px 24px;
        padding-top: 24px;
      }
    }

    &__header {
      display: flex;
      margin-bottom: 8px;
    }

    &__header-left {
      font-size: 0;
      line-height: 0;
      align-self: center;
    }

    &__header-left + &__header-right {
      margin-left: 8px;
    }

    &__avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
    }

    &__user-name {
      @include fontH4AccentNormalText;
    }

    &__date {
      @include fontTinyText;
    }
  }
</style>
